import React from 'react';
import { NavLink } from "react-router-dom";
import { YouTube, Facebook, Twitter, Instagram } from "@material-ui/icons";
import { deepOrange } from '@material-ui/core/colors';

const Services = () => {
    return (
        <section id="footer">
            <div className="footer-dark">
                <footer>
                    <div className="container">
                        <div className="row">
                            <div className="col item social">
                                <a href="www.onedotall.in"><YouTube style={{ color: deepOrange[600]}} /></a>
                                <a href="www.onedotall.in"><Facebook style={{ color: deepOrange[600] }} /></a>
                                <a href="www.onedotall.in"><Twitter style={{ color: deepOrange[600] }} /></a>
                                <a href="www.onedotall.in"><Instagram style={{ color: deepOrange[600] }} /></a>
                            </div>
                        </div>
                        <p className="copyright">
                            One.all &nbsp; | &nbsp;
                            <NavLink className="copyright" to="/policy">Privacy Policy</NavLink> &nbsp; | &nbsp;
                            © {(new Date().getFullYear())}
                        </p>
                    </div>
                </footer>
            </div>
        </section>
    )
}

export default Services

